import { render } from "./PZeroState.vue?vue&type=template&id=6f0b4f30&scoped=true"
import script from "./PZeroState.vue?vue&type=script&lang=js"
export * from "./PZeroState.vue?vue&type=script&lang=js"

import "./PZeroState.vue?vue&type=style&index=0&id=6f0b4f30&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0b4f30"]])

export default __exports__